export default "__VITE_ASSET__BfwbKUrN__";